import {useMemo} from 'react';
import {isArray, isString} from 'lodash-es';

import * as store from '@/store';
import routers, {buildPath, ServerConfig} from '@/config/routers';
import toast, {ToastType} from '@/components/Toast';
import {shareToRuLiu} from '@/components/Share/commentShare';
import {copyText} from '@/utils/commonUtils';
import {feLogger, lineationCommentShareBtnClick} from '@/buried';
import {parse, addParamToCustomUrl} from '@/utils/kuQuery';
import KU_QUERY from '@/constants/common/searchParamKeys';

import styles from './index.module.scss';
import {getIsSdkPage} from '@/kuSdk/view/DocViewAll/utils/isSdkPage';

export const useCommentLocationOptions = () => {
    return useMemo(() => {
        return {
            getCommentIdByUrl() {
                const queryObj = parse(window.location.search);
                let rightCommentId: string = '';
                if (isString(queryObj[KU_QUERY.document.rightCommentId])) {
                    rightCommentId = queryObj[KU_QUERY.document.rightCommentId] as string;
                } else if (isArray(queryObj[KU_QUERY.document.rightCommentId])) {
                    rightCommentId = queryObj[KU_QUERY.document.rightCommentId]![0];
                }
                return rightCommentId;
            },
            commentHasDeleted() {
                const queryObj = parse(window.location.search);
                let rlNotice: string = '';
                if (isString(queryObj[KU_QUERY.document.rlNotice])) {
                    rlNotice = queryObj[KU_QUERY.document.rlNotice] as string;
                }
                let toastContent = '评论未发布或已删除';
                if (rlNotice === '1') {
                    toastContent = '评论已删除';
                }
                setTimeout(() => {
                    toast({
                        duration: 6000,
                        type: ToastType.Error,
                        content: toastContent,
                    });
                }, 600);
            },
        };
    }, []);
};

export const useCommentShareAndCopy = () => {
    return (commentId: string) => {
        const curDoc = store.getCurDocument();
        if (!curDoc || !commentId) {
            return;
        }
        const path = buildPath(routers.Knowledge.docPath, {
            spaceGuid: curDoc.spaceGuid!,
            groupGuid: curDoc.groupGuid!,
            repositoryGuid: curDoc.repositoryGuid,
            docGuid: curDoc.docGuid,
        });
        let url = addParamToCustomUrl(
            ServerConfig.origin + path,
            KU_QUERY.document.block_id,
            ''
        ).href;
        url = addParamToCustomUrl(
            url,
            KU_QUERY.document.rightCommentId,
            commentId
        ).href;

        shareToRuLiu(url);
        if (!getIsSdkPage()) {
            copyText(url);
            toast({content: '复制链接成功，可进行粘贴或直接分享至如流', duration: 3000, type: ToastType.Success, className: styles.toast});
        }
        feLogger(lineationCommentShareBtnClick());
    };
};
